import * as yup from 'yup';
import {
  AUTH_PASSWORD_CONFIRMATION_ERROR,
  AUTH_PASSWORD_MIN_LENGTH,
  getDefaultAuthPasswordRequirementsMessage,
} from 'common/constants/auth';
import {
  SET_NEW_PASSWORD_CONFIRMATION_REQUIRED_ERROR,
  SET_NEW_PASSWORD_REQUIRED_ERROR,
} from './SetNewPassword.constants';

const defaultAuthPasswordRequirementsMessage = getDefaultAuthPasswordRequirementsMessage();

export const SET_NEW_PASSWORD_SCHEMA = yup.object({
  password: yup
    .string()
    .required(SET_NEW_PASSWORD_REQUIRED_ERROR)
    .min(AUTH_PASSWORD_MIN_LENGTH, defaultAuthPasswordRequirementsMessage)
    .matches(/[A-Za-z]/, defaultAuthPasswordRequirementsMessage)
    .matches(/\d/, defaultAuthPasswordRequirementsMessage)
    .matches(/\W/, defaultAuthPasswordRequirementsMessage),
  passwordConfirmation: yup
    .string()
    .required(SET_NEW_PASSWORD_CONFIRMATION_REQUIRED_ERROR)
    .oneOf([yup.ref('password')], AUTH_PASSWORD_CONFIRMATION_ERROR),
});
